module.exports = __webpack_public_path__ + "static/media/image_7.179ca515.jpg";